import { BRIDGE_BIO_CAMPAIGN_CODE } from '@constants/bridgeBio';
import { ROUTES } from '@constants/routes';

export type FvtOnlyProbandInput = {
  campaignCode: string;
  hasFVTReferral: boolean;
  hasLoadedTestRequests: boolean;
  ownTestRequestCount: number;
};

export const isFvtOnlyProband = ({
  campaignCode,
  hasFVTReferral,
  hasLoadedTestRequests,
  ownTestRequestCount,
}: FvtOnlyProbandInput): boolean =>
  campaignCode === BRIDGE_BIO_CAMPAIGN_CODE && hasFVTReferral && hasLoadedTestRequests && ownTestRequestCount === 0;

export const FVT_ONLY_PROBAND_BLOCKED_PATHS = [
  ROUTES.HOME,
  ROUTES.RESULTS,
  ROUTES.MY_ORDERS,
  ROUTES.SHARE_RESULTS,
  ROUTES.REPORTS,
  ROUTES.GENETIC_COUNSELING,
] as const;

export const isFvtOnlyProbandBlockedPath = (path: string): boolean =>
  (FVT_ONLY_PROBAND_BLOCKED_PATHS as readonly string[]).includes(path);
